import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

export default function Blog() {
  const navigate = useNavigate();
  
  const blogPosts = [
    { id: 1, title: 'Trendyol Ürün Sorularını Otomatik Cevaplama: Tam Rehber', excerpt: 'Trendyol mağazanızda gelen ürün sorularını AI ile nasıl otomatik yanıtlayabileceğinizi öğrenin.', date: '2025-10-01', readTime: '5 dk', category: 'Rehber' },
    { id: 2, title: 'Trendyol Mağazanızda Yanıt Süresini Nasıl Kısaltırsınız?', excerpt: 'Hızlı yanıt müşteri memnuniyetini artırır. AI asistan ile 7/24 destek sağlayın.', date: '2025-09-28', readTime: '4 dk', category: 'İpuçları' },
    { id: 3, title: 'Hepsiburada ve Trendyol Sorularını Tek Yerden Yönetin', excerpt: 'Çoklu mağaza yönetimi ile tüm platformları tek ekrandan takip edin.', date: '2025-09-25', readTime: '6 dk', category: 'Özellikler' },
    { id: 4, title: 'AI ile Hibrit vs Full-Auto Mod: Hangisi Sizin İçin?', excerpt: 'İki mod arasındaki farkları ve hangisinin işiniz için daha uygun olduğunu keşfedin.', date: '2025-09-20', readTime: '5 dk', category: 'Karşılaştırma' },
    { id: 5, title: 'E-Pazaryeri Satıcıları İçin Müşteri Soruları Yönetimi', excerpt: 'En yaygın müşteri soruları ve AI ile nasıl yanıtlanacağı hakkında best practice\'ler.', date: '2025-09-15', readTime: '7 dk', category: 'Best Practices' },
    { id: 6, title: 'Trendyol Satış Performansınızı AI ile Nasıl Artırırsınız?', excerpt: 'Hızlı yanıt vermenin satışlara etkisi ve AI asistanın ROI analizi.', date: '2025-09-10', readTime: '6 dk', category: 'Analiz' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-orange-100 text-[#FF6000] hover:bg-orange-100">Blog</Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">E-Ticaret & AI</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">En son trendler, ipuçları ve rehberler</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Card key={post.id} className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => navigate(`/blog/${post.id}`)}>
              <CardContent className="p-6">
                <Badge className="mb-3 bg-orange-100 text-[#FF6000] hover:bg-orange-100">{post.category}</Badge>
                <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-[#FF6000] transition-colors">{post.title}</h3>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                  <div className="flex items-center gap-1"><Calendar className="h-4 w-4" /><span>{post.date}</span></div>
                  <div className="flex items-center gap-1"><Clock className="h-4 w-4" /><span>{post.readTime}</span></div>
                </div>
                <button className="flex items-center gap-2 text-[#FF6000] hover:gap-3 transition-all font-semibold">
                  Devamını Oku <ArrowRight className="h-4 w-4" />
                </button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
